module.exports = __webpack_public_path__ + "ad312b925213089b9b3add93045a4ae5.MP3";